import { create } from 'zustand';

const ACTIVE_COMPANY_STORAGE_KEY = '#organization#active-company';

const getActiveCompanyIdFromStorage = () => {
  try {
    return localStorage.getItem(ACTIVE_COMPANY_STORAGE_KEY) || undefined;
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return undefined;
  }
};

interface State {
  activeCompanyId?: string;
  setActiveCompanyId: (id: string) => void;
  unsetActiveCompany: () => void;
}

export const organizationStore = create<State>((set) => ({
  activeCompanyId: getActiveCompanyIdFromStorage(),
  setActiveCompanyId: (id) => {
    localStorage.setItem(ACTIVE_COMPANY_STORAGE_KEY, id);
    return set({ activeCompanyId: id });
  },
  unsetActiveCompany: () => {
    localStorage.removeItem(ACTIVE_COMPANY_STORAGE_KEY);
    return set({ activeCompanyId: undefined });
  },
}));

const lastActiveCompanyId = getActiveCompanyIdFromStorage();
let hasReactedToActiveCompanyChange = false;

const syncActiveCompany = () => {
  if (hasReactedToActiveCompanyChange) {
    return;
  }
  const storedActiveCompanyId = getActiveCompanyIdFromStorage();
  if (storedActiveCompanyId !== lastActiveCompanyId) {
    hasReactedToActiveCompanyChange = true;
    console.log('Has active company changed:', {
      from: lastActiveCompanyId,
      to: storedActiveCompanyId,
    });
    window.location.replace('/');
  }
};

window.addEventListener('focus', syncActiveCompany);

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    syncActiveCompany();
  }
});
